import { MenuBook } from "@mui/icons-material"
import { Tab, Tabs } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { Fragment, useState } from "react"
import RelatoriosConfig from "./RelatoriosConfig/RelatoriosConfig"

const tabsOptions = [
    {
        label: "Relatórios",
        componente: RelatoriosConfig,
        icon: MenuBook
    }
]

const RelatoriosPage = () => {
    const [tabIndex, setTabIndex] = useState(0)

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex)
    }

    return (
        <Grid sx={{ width: '100%', height: '100%', padding: '10px', display: 'flex', flexFlow: 'column' }}>
            <Tabs
                value={tabIndex}
                onChange={handleTabChange}
                // variant="fullWidth"
                sx={{
                    flexGrow: 0,
                    flexBasis: 'auto',
                    padding: 0,
                    margin: 0,
                    borderBottom: '1px solid white',
                    height: '35px',
                    minHeight: '35px',
                    color: "#fff",
                    '& .MuiTabs-indicator': { display: 'none' },
                    '& .MuiTab-root': {
                        padding: 1,
                        margin: 0,
                        minHeight: '35px',
                        height: '35px',
                        color: "#fff !important",
                        borderBottom: '1px solid #fff',
                        fontSize: '0.8vmax',
                        fontWeight: 700
                    },
                    '& .Mui-selected': {
                        color: "#fff",
                        borderLeft: 'white solid 0.5px',
                        borderRight: 'white solid 0.5px',
                        borderTop: 'white solid 0.5px',
                        borderBottom: '0px',
                        borderRadius: '5px 5px 0 0',
                        padding: 1,
                        margin: 0
                    }
                }}
            >
                {tabsOptions.map((tab) => {
                    return (
                        <Tab
                            key={tab.label}
                            icon={<tab.icon/>}
                            iconPosition="start"
                            label={tab.label}
                        />
                    )
                })}
            </Tabs>

            <Grid container sx={{ paddingTop: '10px', display: 'flex', flexBasis: 'auto', flexGrow: 1, overflowY: 'hidden' }}>
                {tabsOptions.map((tab, index) => {
                    return (
                        <Fragment key={index}>
                            {tabIndex === index &&
                                <tab.componente key={tab.label}/>
                            }
                        </Fragment>
                    )
                })}
            </Grid>

        </Grid>
    )
}

export default RelatoriosPage
